<template>
  <div class="searchorders">
    <h1 class="subheading grey--text">Overview of Payments</h1>

    <v-container class="my-1">
      <v-select
        class="ma-0"
        v-model="yearSelected"
        :items="years"
        menu-props="auto"
        label="Select Starting Year"
        hide-details
        prepend-icon="map"
        single-line
        v-on:change="getPaymentsOverview"
      ></v-select>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="orderAnalyticsList"
        item-key="name"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>View Order analytics</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";
import orderAnalytics from "../modules/orderAnalytics";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      searchTerm: "",
      orderAnalyticsList: [],
      editedItem: {},
      defaultItem: {},
      loading: false,
      headers: [
        { text: "period", value: "month" },
        { text: "Number of orders", value: "orderCount" },
        { text: "Value", value: "orderValue" },
      ],
      years: ['2018', '2019', '2020'],
      yearSelected: '2020',
    };
  },
  created() {
    this.getPaymentsOverview();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    async getPaymentsOverview() {
      this.loading = true;
      const paymentResults = await orderAnalytics.getPaymentHistory(this.yearSelected);

      this.orderAnalyticsList = paymentResults.ordersByMonth;
      // await this.doFilter();
      this.loading = false;
    },
    async doFilter() {
      if (!this.searchTerm || this.searchTerm.length == 0) {
        this.postalrateList = this.postalratesRaw;
      } else {
        this.postalrateList = this.postalratesRaw.filter(
          (postalrate) =>
            postalrate.description.includes(this.searchTerm) ||
            postalrate.packaging.includes(this.searchTerm)
        );
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.getpostalrateList();
    },
  },
};
</script>
